// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__SW0hx","navbar_scrolled":"Navbar_navbar_scrolled__Vum9f","scrolling":"Navbar_scrolling__tY4tD"};